<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">

      <b-form @submit.prevent="submitForm">
        <b-card-header class="border-0 pl-0">
          <h3 class="mb-0">{{ $t('nueva_empresa') }}</h3>
        </b-card-header>
        <b-row class="card-ing">
          <b-col md="2">
            <b-form-group label-for="estado">
              <template v-slot:label>
                {{ $t('nombre') }} <span class="text-danger">*</span>
              </template>
              <b-form-input id="estado" v-model="form.nombre" required
                :placeholder="$t('ingrese_estado')"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label-for="rut">
              <template v-slot:label>
                {{ $t('rut') }} <span class="text-danger">*</span>
              </template>
              <b-form-input id="rut" v-model="form.rut" required :placeholder="$t('ingrese_rut')"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="País" label-for="paisID">
              <template v-slot:label>
                {{ $t('pais') }} <span class="text-danger">*</span>
              </template>
              <el-select class="custom-input" v-model="form.paisID" required filterable @change="onChangePais"
                :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                <el-option v-for="item in paisOptions" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Industria" label-for="industriaID">
              <template v-slot:label>
                {{ $t('industria') }}
              </template>
              <b-form-select id="industriaID" v-model="form.industriaID">
                <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                <option v-for="option in industriasOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Empresa" label-for="sectorID">
              <template v-slot:label>
                {{ $t('sector') }}
              </template>
              <b-form-select id="sectorID" v-model="form.sectorID">
                <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                <option v-for="option in sectoresOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>

              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form-group label-for="regionID">
              <template v-slot:label>
                {{ $t('region') }} <span class="text-danger">*</span>
              </template>
              <el-select class="custom-input" :disabled="!(this.form.paisID > 0)" required v-model="form.regionID" filterable
                @change="onChangeRegion" :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                <el-option :value="null" :label="$t('seleccione_opcion')" />
                <el-option v-for="item in regionOptions" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label-for="comunaID">
              <template v-slot:label>
                {{ $t('comuna') }} <span class="text-danger">*</span>
              </template>
              <el-select class="custom-input" :disabled="!(this.form.paisID > 0)" required v-model="form.comunaID" filterable
                :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                <el-option :value="null" :label="$t('seleccione_opcion')" />
                <el-option v-for="item in comunasOptions" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label-for="direccion">
              <template v-slot:label>
                {{ $t('calle') }} <span class="text-danger">*</span>
              </template>
              <b-form-input id="direccion" v-model="form.direccion" required
                placeholder="Ingrese direccion"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label-for="numero">
              <template v-slot:label>
                {{ $t('Numero') }}
              </template>
              <b-form-input type="number" id="numeroDireccion" v-model="form.numeroDireccion"
                placeholder="Ingrese #"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label-for="parcela">
              <template v-slot:label>
                {{ $t('dir_lugar_tipo') }}
              </template>
              <b-form-input id="parcela" v-model="form.parcela"
                :placeholder="'Ingrese ' + $t('dir_lugar_tipo')"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button variant="danger" class="ml-2" @click="$router.push('/empresas')">
          <i class="fas fa-arrow-left"></i> {{ $t('cancelar') }}
        </b-button>
        <b-button type="submit" variant="primary">
          {{ $t('guardar') }}
        </b-button>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import empresaService from '@/api/empresaService';
import miscService from '@/api/miscService';
import { Select, Option } from 'element-ui'
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      form: {
        nombre: '',
        rut: '',
        sectorID: null,
        industriaID: null,
        paisID: null,
        regionID: null,
        comunaID: null

      },
      paisOptions: [],
      industriasOptions: [],
      sectoresOptions: [],
      regionOptions: [],
      comunasOptions: []
    };
  },
  async beforeMount() {
    this.paisOptions = await miscService.getPaisesOptions();
    this.industriasOptions = await miscService.getIndustriaOptions();
    this.sectoresOptions = await miscService.getSectorOptions();
    if (this.form.paisID > 0)
      this.regionOptions = await miscService.getRegionesOptions(this.form.paisID);
    if (this.form.regionID > 0)
      this.comunasOptions = await miscService.getComunasOptions(this.form.regionID);
  },
  methods: {
    async onChangePais() {

      this.form.regionID = null;
      this.form.comunaID = null;
      if (this.form.paisID > 0)
        this.regionOptions = await miscService.getRegionesOptions(this.form.paisID);

    },
    async onChangeRegion() {
      this.form.comunaID = null;
      if (this.form.regionID > 0)
        this.comunasOptions = await miscService.getComunasOptions(this.form.regionID);
    },
    async submitForm() {
      Swal.fire({
        title: this.$t('guardar'),
        text: this.$t('estas_seguro_guardar'),
        icon: 'info',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await empresaService.create(this.form);
            if (!response) throw new Error('Ocurrio un error al crear la empresa, intente nuevamente.');
            Swal.fire({
              title: "Creado correctamente",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
            this.$router.push(`/empresas/details/${response.empresaID}`);
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message
            });
          }
        }
        else if (result.isDenied) {
          Swal.close();
        }
      });
    }
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}

.row.card-ing {
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
  padding: 30px 0px;
  margin-bottom: 20px;
}
</style>
